<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="certifications__background module__background"
        ></app-modulebackground>
        <div
            class="certifications__container module__container"
            v-bind:class="{
                container__boxed: [1, 2, 5, 6].includes(module.layout.type),
                container__fluid: [3, 4].includes(module.layout.type)
            }"
        >
            <div class="certifications__inner module__inner">
                <div
                    class="certifications__inner--main module__inner--main"
                    v-bind:class="{
                        'calc-padding--left': [3].includes(module.layout.type),
                        'calc-padding--right': [4].includes(module.layout.type)
                    }"
                >
                    <div
                        class="certifications__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="certifications__inner-col module__inner-col">
                            <div class="certifications__header module__header">
                                <h2
                                    class="certifications__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="certifications__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="certifications__inner-row module__inner-row">
                        <div class="certifications__inner-col module__inner-col">
                            <div class="certifications__content-block module__content-block">
                                <div
                                    class="certifications__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [5, 6].includes(module.layout.type)
                                    }"
                                    v-if="
                                        module.data.text ||
                                            ([5, 6].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 &&
                                                        module.data.link3.active)))
                                    "
                                >
                                    <div
                                        class="certifications__inner-row module__inner-row"
                                        v-if="module.data.text"
                                    >
                                        <div class="certifications__inner-col module__inner-col">
                                            <div
                                                class="certifications__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="certifications__inner-row module__inner-row"
                                        v-if="
                                            [5, 6].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 && module.data.link3.active))
                                        "
                                    >
                                        <div class="certifications__inner-col module__inner-col">
                                            <div class="certifications__cta module__cta">
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link"
                                                    :custom-class="
                                                        'certifications__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link2"
                                                    :custom-class="
                                                        'certifications__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link3"
                                                    :custom-class="
                                                        'certifications__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="certifications__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [5, 6].includes(module.layout.type)
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="certifications__inner-row module__inner-row">
                                        <div class="certifications__inner-col module__inner-col">
                                            <div class="certifications__list module__list">
                                                <div
                                                    v-for="items__value in items"
                                                    v-bind:key="items__value.id"
                                                    :data-preset-id="items__value.preset_id"
                                                    class="certifications__list-item module__list-item"
                                                    v-bind:data-valid-until="
                                                        items__value.data &&
                                                        items__value.data.expires
                                                            ? items__value.data.expires
                                                            : false
                                                    "
                                                    v-bind:class="{
                                                        'col__width--one-quarter': [1, 2].includes(
                                                            module.layout.type
                                                        ),
                                                        'col__width--full': [3, 4, 5, 6].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                >
                                                    <div
                                                        class="certifications__teaser-box"
                                                        v-if="items__value.data"
                                                        v-bind:class="{
                                                            'module__teaser-box--horizontal': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'module__teaser-box--vertical': [
                                                                3,
                                                                4,
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <component
                                                            :is="
                                                                items__value.data &&
                                                                items__value.data.name &&
                                                                items__value.data.file
                                                                    ? 'a'
                                                                    : 'div'
                                                            "
                                                            :href="
                                                                items__value.data.file
                                                                    ? generateMediaUrl({
                                                                          id:
                                                                              items__value.data.file
                                                                                  .id
                                                                      })
                                                                    : ''
                                                            "
                                                            target="_blank"
                                                            class="certifications__teaser-box-header"
                                                        >
                                                            <app-moduleimage
                                                                v-if="
                                                                    [1, 2].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                                :data="items__value.data.image"
                                                                :tag="'img'"
                                                                :custom-class="
                                                                    'certifications__teasers-image module__image'
                                                                "
                                                            ></app-moduleimage>
                                                            <app-moduleicon
                                                                v-if="
                                                                    [3, 4, 5, 6].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                                :data="
                                                                    items__value.data.icon || {
                                                                        id: getRandomImageInNamespace(
                                                                            'icons/certifications/default'
                                                                        )
                                                                    }
                                                                "
                                                                :custom-class="
                                                                    'certifications__teasers-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                        </component>

                                                        <div
                                                            class="certifications__teaser-box-text module__teaser-box-text"
                                                        >
                                                            <component
                                                                :is="
                                                                    items__value.data &&
                                                                    items__value.data.name &&
                                                                    items__value.data.file
                                                                        ? 'a'
                                                                        : 'div'
                                                                "
                                                                :href="
                                                                    items__value.data.file
                                                                        ? generateMediaUrl({
                                                                              id:
                                                                                  items__value.data
                                                                                      .file.id
                                                                          })
                                                                        : ''
                                                                "
                                                                target="_blank"
                                                                class="certifications__label module__label font-bold color-p"
                                                            >
                                                                {{ items__value.data.name }}
                                                            </component>
                                                            <a
                                                                v-if="
                                                                    items__value.data.linkActive ==
                                                                        1 &&
                                                                        items__value.data.link !==
                                                                            undefined &&
                                                                        items__value.data.link !==
                                                                            null &&
                                                                        items__value.data.link !==
                                                                            '' &&
                                                                        items__value.data
                                                                            .linkText !==
                                                                            undefined &&
                                                                        items__value.data
                                                                            .linkText !== null &&
                                                                        items__value.data
                                                                            .linkText !== '' &&
                                                                        items__value.data.link !==
                                                                            'https://www.tecworld.com'
                                                                "
                                                                :href="items__value.data.link || ''"
                                                                class="certifications__link module__label color-p"
                                                                target="_blank"
                                                            >
                                                                <span>
                                                                    {{ items__value.data.linkText }}
                                                                </span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="certifications__inner-row module__inner-row"
                        v-if="
                            [1, 2, 3, 4].includes(module.layout.type) &&
                                ((module.data.link && module.data.link.active) ||
                                    (module.data.link2 && module.data.link2.active) ||
                                    (module.data.link3 && module.data.link3.active))
                        "
                    >
                        <div class="certifications__inner-col module__inner-col">
                            <div class="certifications__cta module__cta">
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link"
                                    :custom-class="
                                        'certifications__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link2"
                                    :custom-class="
                                        'certifications__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link3"
                                    :custom-class="
                                        'certifications__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="certifications__inner--image module__inner--image"
                    v-if="
                        [3, 4].includes(module.layout.type) &&
                            module.data.image &&
                            module.data.image.id
                    "
                >
                    <app-moduleimage
                        v-if="[3, 4].includes(module.layout.type)"
                        :data="module.data.image"
                        :tag="'div'"
                        :custom-class="'certifications__moduleimage module__moduleimage'"
                    ></app-moduleimage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Certifications from '@/external/assorted/Certifications';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-moduleicon': ModuleIcon,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems', 'getRandomImageInNamespace', 'generateMediaUrl', 'getProp']),
        items() {
            return this.getListItems('deha.user.misc.certifications');
        }
    },
    props: {
        module: Object
    },
    mounted() {
        Certifications.init();
    },
    updated() {
        Certifications.init();
    }
};
</script>
